import { create } from "zustand";

type QuickPostV3View = "composer" | "settings";

interface QuickPostV3ModalState {
  goToComposer: () => void;
  goToSettings: () => void;
  isDirty: boolean;
  isFullscreen: boolean;
  isSubmitting: boolean;
  reset: () => void;
  setIsDirty: (isDirty: boolean) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  toggleFullscreen: () => void;
  view: QuickPostV3View;
}

const initialState = {
  isDirty: false,
  isFullscreen: false,
  isSubmitting: false,
  view: "composer" as QuickPostV3View,
};

export const useQuickPostV3ModalStore = create<QuickPostV3ModalState>(set => ({
  ...initialState,
  goToComposer: () => set({ view: "composer" }),
  goToSettings: () => set({ view: "settings" }),
  reset: () => set(initialState),
  setIsDirty: (isDirty: boolean) => set({ isDirty }),
  setIsSubmitting: (isSubmitting: boolean) => set({ isSubmitting }),
  toggleFullscreen: () => set(state => ({ isFullscreen: !state.isFullscreen })),
}));
